import { render, staticRenderFns } from "./larval_surveillance.vue?vue&type=template&id=12457049&"
import script from "./larval_surveillance.vue?vue&type=script&lang=js&"
export * from "./larval_surveillance.vue?vue&type=script&lang=js&"
import style0 from "./larval_surveillance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports